import './bootstrap'

var CutawayApp = {

}
window.CutawayApp = CutawayApp